import { useReducer, useCallback } from 'react';
import { calculationReducer, initialState } from './calculationReducer';

export function useCalculation() {
    const [state, dispatch] = useReducer(calculationReducer, initialState);

    // === LOAD & RESET ===
    const loadCalculation = useCallback((data) => {
        dispatch({ type: 'LOAD_CALCULATION', payload: data });
    }, []);

    const resetCalculation = useCallback(() => {
        dispatch({ type: 'RESET_CALCULATION' });
    }, []);

    // === TARIFF ===
    const setTariff = useCallback((tariff) => {
        dispatch({ type: 'SET_TARIFF', payload: tariff });
    }, []);

    const updateTariffData = useCallback((tariffData) => {
        dispatch({ type: 'UPDATE_TARIFF_DATA', payload: tariffData });
    }, []);

    // === STAFF ===
    const setStaff = useCallback((staff) => {
        dispatch({ type: 'SET_STAFF', payload: staff });
    }, []);

    const setConductor = useCallback((conductor) => {
        dispatch({ type: 'SET_CONDUCTOR', payload: conductor });
    }, []);

    const setOthers = useCallback((others) => {
        dispatch({ type: 'SET_OTHERS', payload: others });
    }, []);

    // === EVENTS ===
    const setEvents = useCallback((events) => {
        dispatch({ type: 'SET_EVENTS', payload: events });
    }, []);

    const setEventDetail = useCallback((eventDetail) => {
        dispatch({ type: 'SET_EVENT_DETAIL', payload: eventDetail });
    }, []);

    const setDetails = useCallback((details) => {
        dispatch({ type: 'SET_DETAILS', payload: details });
    }, []);

    const setKzmProject = useCallback((value) => {
        dispatch({ type: 'SET_KZM_PROJECT', payload: value });
    }, []);

    // === RATES ===
    const updateRates = useCallback((rateType, category, values) => {
        dispatch({
            type: 'UPDATE_RATES',
            payload: { rateType, category, values }
        });
    }, []);

    const setAllRates = useCallback((rates) => {
        dispatch({ type: 'SET_ALL_RATES', payload: rates });
    }, []);

    // Helper functions for backward compatibility
    const setClientKzm = useCallback((values) => {
        updateRates('client', 'kzm', values);
    }, [updateRates]);

    const setClientMus = useCallback((values) => {
        updateRates('client', 'mus', values);
    }, [updateRates]);

    const setEstroKzm = useCallback((values) => {
        updateRates('estro', 'kzm', values);
    }, [updateRates]);

    const setEstroMus = useCallback((values) => {
        updateRates('estro', 'mus', values);
    }, [updateRates]);

    // === COSTS ===
    const updateCost = useCallback((costType, data) => {
        dispatch({
            type: 'UPDATE_COST',
            payload: { costType, data }
        });
    }, []);

    const setAllCosts = useCallback((costs) => {
        dispatch({ type: 'SET_ALL_COSTS', payload: costs });
    }, []);

    // Helper functions for backward compatibility
    const setRenting = useCallback((data) => {
        updateCost('renting', data);
    }, [updateCost]);

    const setAdministration = useCallback((data) => {
        updateCost('administration', data);
    }, [updateCost]);

    const setTransport = useCallback((data) => {
        updateCost('transport', data);
    }, [updateCost]);

    const setArchiving = useCallback((data) => {
        updateCost('archiving', data);
    }, [updateCost]);

    // === TRANSPORT ===
    const setTransp30km = useCallback((value) => {
        dispatch({ type: 'SET_TRANSP_30KM', payload: value });
    }, []);

    const setProject30kmAway = useCallback((data) => {
        dispatch({ type: 'SET_PROJECT_30KM_AWAY', payload: data });
    }, []);

    const setConductor30kmAway = useCallback((data) => {
        dispatch({ type: 'SET_CONDUCTOR_30KM_AWAY', payload: data });
    }, []);

    // === META ===
    const setCalculationName = useCallback((name) => {
        dispatch({ type: 'SET_CALCULATION_NAME', payload: name });
    }, []);

    const setCalculationNotes = useCallback((notes) => {
        dispatch({ type: 'SET_CALCULATION_NOTES', payload: notes });
    }, []);

    const setProgram = useCallback((tasks) => {
        dispatch({ type: 'SET_PROGRAM', payload: tasks });
    }, []);

    const setFolder = useCallback((folder) => {
        dispatch({ type: 'SET_FOLDER', payload: folder });
    }, []);

    const setEventDuration = useCallback((duration) => {
        dispatch({ type: 'SET_EVENT_DURATION', payload: duration });
    }, []);

    return {
        // State
        state,
        dispatch, // Dla zaawansowanych przypadków

        // Actions
        loadCalculation,
        resetCalculation,

        // Tariff
        setTariff,
        updateTariffData,

        // Staff
        setStaff,
        setConductor,
        setOthers,

        // Events
        setEvents,
        setEventDetail,
        setDetails,
        setKzmProject,

        // Rates
        updateRates,
        setAllRates,
        setClientKzm,
        setClientMus,
        setEstroKzm,
        setEstroMus,

        // Costs
        updateCost,
        setAllCosts,
        setRenting,
        setAdministration,
        setTransport,
        setArchiving,

        // Transport
        setTransp30km,
        setProject30kmAway,
        setConductor30kmAway,

        // Meta
        setCalculationName,
        setCalculationNotes,
        setProgram,
        setFolder,
        setEventDuration,
    };
}
